import { C } from "./theme";

export const LogoImg = ({ h = 32 }) => (
  <img
    src="/aiatus.png"
    alt="AIATUS"
    style={{ height: h, objectFit: "contain" }}
    onError={e => {
      e.target.onerror = null;
      e.target.style.display = "none";
      const d = document.createElement("div");
      d.style.cssText = `background:${C.pri};border-radius:6px;padding:4px 12px;display:inline-flex;align-items:center;height:${h}px`;
      d.innerHTML = `<span style="font-family:Outfit,sans-serif;font-weight:900;font-size:${h * 0.4}px;color:#fff;letter-spacing:2px">AIATUS</span>`;
      e.target.parentNode.insertBefore(d, e.target.nextSibling);
    }}
  />
);
